import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { AdminBaseQueryDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminBaseQueryResultFragment } from '@docpace/admin-graphql'
import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { ctxAdminIdAtom, ctxPracticeIdAtom } from '@docpace/shared-react-atoms'

const typedAdminBaseQueryDocument = AdminBaseQueryDocument as TypedDocumentNode<AdminBaseQueryResultFragment>

export function useAdminBaseQuery(opts?: useQuery.Options<AdminBaseQueryResultFragment>){
    return useQuery(typedAdminBaseQueryDocument, opts)
}

export interface UseContextAdminBaseQueryParams {
    isAuthPage?: boolean
}

export function useContextAdminBaseQuery(params?: UseContextAdminBaseQueryParams){
    
    const { isAuthPage } = params ?? {}
    const [ adminId, setCtxAdminId ] = useAtom(ctxAdminIdAtom)

    function setContextIds({ practiceId, adminId, managerId }: AdminBaseQueryResultFragment){
        setCtxAdminId(adminId ?? undefined)
    }

    const adminBaseQueryResult = useAdminBaseQuery({
        skip: isAuthPage,
    })

    useEffect(() => {
        if (adminBaseQueryResult.data) setContextIds(adminBaseQueryResult.data)
    }, [adminBaseQueryResult.data])
   
    return {
        ...adminBaseQueryResult,
        // prevent anything downstream in the context from receiving an admin if 
        // a manager account override is being used
        adminId, 
        serverInfo: adminBaseQueryResult?.data?.serverInfo,
    }
}
